import UploadPhoto from "./UploadPhoto";

export default UploadPhoto;
